import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { searchPlatformRouter } from './routing/searchPlatformRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { searchPlatformViewAccessControl } from './access-control/searchPlatformAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'search-platform',
  totem: {
    tool: 'search-platform-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    partnerScoped: [searchPlatformRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Merchandising,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View search results listings in search platform',
          labelId: 'searchPlatformDomain.navigation.searchResults',
          route: 'search-platform-search-results',
          subRoutes: ['search-platform-create', 'search-platform-edit'],
          accessControl: searchPlatformViewAccessControl,
          positionNavV2: 11,
        },
      ],
    },
    {
      attachToV3: NavEntryPointV3.StorefrontPro,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View search results listings in search platform',
          labelId: 'searchPlatformDomain.navigation.searchResults',
          labelIdV3: 'searchPlatformDomain.navigation.searchResults.v3',
          route: 'search-platform-search-results',
          accessControl: searchPlatformViewAccessControl,
          positionNavV3: 16,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `pnpm ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
